import React from "react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"; 
import Properties from "./Components/Pages/Properties/Properties";
import PropertyDetails from "./Components/Pages/Properties/PropertyDetails";
import CustomeNavbar from "./Components/Pages/Properties/Navbar";
import PropertySearch from "./Components/Pages/Properties/search";
import Homepage from "./Components/Pages/Properties/Home";
import Footerpage from "./Components/Pages/Properties/Footer";
import ContactusPage from "./Components/Pages/Properties/Contactus";
import AboutusPage from "./Components/Pages/Properties/Aboutus";
import DevelopmentSection from "./Components/Pages/Properties/toronto";
import DubaidevelopmentSection from "./Components/Pages/Properties/dubaidevelopment";

function App() {
  return (
    <Router>
      <CustomeNavbar />
      <Routes>
        <Route path="/" element={<Homepage/>} />
        <Route path="/properties" element={<Properties />} />
        <Route path="/property/:listingKey" element={<PropertyDetails />} />
        <Route path="/contact-us" element={<ContactusPage />} />
        <Route path="/about-us" element={<AboutusPage />} />
        <Route path="/toronto-developments" element={<DevelopmentSection />} />
        <Route path="/dubai-developments" element={<DubaidevelopmentSection />} />
      </Routes>
      <Footerpage/>
    </Router>
  );
}

export default App;
